// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

/**
 * One valued LN2 leaf that carries the decoded number.
 */
export class ValuedRule implements flatbuffers.IUnpackableObject<ValuedRuleT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): ValuedRule {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsValuedRule(bb: flatbuffers.ByteBuffer, obj?: ValuedRule): ValuedRule {
    return (obj || new ValuedRule()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsValuedRule(bb: flatbuffers.ByteBuffer, obj?: ValuedRule): ValuedRule {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new ValuedRule()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  template(): number {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.readUint32(this.bb_pos + offset) : 0;
  }

  activeWhenNonzero(): boolean {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : false;
  }

  static startValuedRule(builder: flatbuffers.Builder) {
    builder.startObject(2);
  }

  static addTemplate(builder: flatbuffers.Builder, template: number) {
    builder.addFieldInt32(0, template, 0);
  }

  static addActiveWhenNonzero(builder: flatbuffers.Builder, activeWhenNonzero: boolean) {
    builder.addFieldInt8(1, +activeWhenNonzero, +false);
  }

  static endValuedRule(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    return offset;
  }

  static createValuedRule(
    builder: flatbuffers.Builder,
    template: number,
    activeWhenNonzero: boolean,
  ): flatbuffers.Offset {
    ValuedRule.startValuedRule(builder);
    ValuedRule.addTemplate(builder, template);
    ValuedRule.addActiveWhenNonzero(builder, activeWhenNonzero);
    return ValuedRule.endValuedRule(builder);
  }

  unpack(): ValuedRuleT {
    return new ValuedRuleT(this.template(), this.activeWhenNonzero());
  }

  unpackTo(_o: ValuedRuleT): void {
    _o.template = this.template();
    _o.activeWhenNonzero = this.activeWhenNonzero();
  }

  unpackFields(...fields: string[]): ValuedRuleT {
    const t = new ValuedRuleT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("template")) {
      t.template = this.template();
    }
    if (fieldSet.has("active_when_nonzero")) {
      t.activeWhenNonzero = this.activeWhenNonzero();
    }
    return t;
  }
}

export class ValuedRuleT implements flatbuffers.IGeneratedObject {
  constructor(
    public template: number = 0,
    public activeWhenNonzero: boolean = false,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    return ValuedRule.createValuedRule(builder, this.template, this.activeWhenNonzero);
  }

  clone(): ValuedRuleT {
    const obj = new ValuedRuleT();
    obj.template = this.template;
    obj.activeWhenNonzero = this.activeWhenNonzero;
    return obj;
  }

  equals(other: ValuedRuleT): boolean {
    if (this.template !== other.template) return false;
    if (this.activeWhenNonzero !== other.activeWhenNonzero) return false;
    return true;
  }
}

export function verifyValuedRule(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    verifier.checkScalarField(tablePos, 4, 4);
    verifier.checkScalarField(tablePos, 6, 1);
  } finally {
    verifier.popDepth();
  }
}
